import { atom } from "jotai";

// 전역 상태 관리
export const storeSearchCategory = atom("");
export const storeSearchSubCategory = atom("");
export const storeSearchCity = atom("");
export const storeSearchGu = atom("");
export const storeSearchKeyword = atom("");

export const storeSearchStart = atom(0);